import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface FinanceTabsConfig {
  aiAnalysis: boolean;
  trends: boolean;
  gapAnalysis: boolean;
  bridgePlan: boolean;
  marginAnalysis: boolean;
}

export const useFinanceTabs = () => {
  const [config, setConfig] = useState<FinanceTabsConfig>({
    aiAnalysis: true,
    trends: true,
    gapAnalysis: true,
    bridgePlan: true,
    marginAnalysis: true,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFinanceTabs = async () => {
      try {
        const { data, error } = await supabase
          .from('finance_tabs')
          .select('*')
          .limit(1)
          .single();

        if (error) {
          console.error('Error fetching finance tabs config:', error);
          return;
        }

        if (data) {
          setConfig({
            aiAnalysis: data.ai_analysis,
            trends: data.trends,
            gapAnalysis: data.gap_analysis,
            bridgePlan: data.bridge_plan,
            marginAnalysis: data.margin_analysis,
          });
        }
      } catch (error) {
        console.error('Error in fetchFinanceTabs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFinanceTabs();
  }, []);

  return { config, isLoading };
};